import React, { useEffect, useState } from "react"
import axios from "axios"
import * as Yup from "yup"
import { Formik } from "formik"
import { useSnackbar } from "notistack"
import { useSelector } from "react-redux"
import {
  Box,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormHelperText,
  Grid,
  TextField,
  Toolbar,
  Typography,
} from "@material-ui/core"
import AddShoppingCartIcon from "@material-ui/icons/Add"
import { DatePicker } from "@material-ui/pickers"
import "moment/locale/es"
import { toDecimal } from "src/utils/toDecimal"
import { StyledButton } from "src/components/Buttons/TgButton"
import * as FirestoreService from "src/views/viewAdministrador/metodosDePago/cuentasBancarias/services/firestore"
import { AccountBalance, Block } from "@material-ui/icons"

const NewBank = ({ Transition }) => {
  const { enqueueSnackbar } = useSnackbar()
  const conjunto = useSelector(state => state.complex.complex)
  const [open, setOpen] = useState(false)
  const [bancos, setBancos] = useState([])
  const [loading, setLoading] = useState(false)
  const [curNumComp, setCurNumComp] = useState([])

  const tipoCuenta = [
    { id: 0, Nombre: "Ahorros" },
    { id: 1, Nombre: "Corriente" },
  ]
  const tipoIdentificacion = [
    { id: 0, Nombre: "Ruc" },
    { id: 1, Nombre: "Cédula" },
    { id: 2, Nombre: "Pasaporte" },
  ]

  useEffect(() => {
    const unsub = FirestoreService.getConjuntoComprobante(
      {
        next: querySnapshot => {
          const Items = querySnapshot
          setCurNumComp((Items.data().NumeroComprobante || 0) * 1)
        },
      },
      conjunto.id
    )
    return () => {
      unsub()
    }
  }, [conjunto.id])

  useEffect(() => {
    const unsub = FirestoreService.getAllBanks({
      next: query => {
        const items = query.docs.map(doc => ({
          ...doc.data(),
          id: doc.id,
        }))
        setBancos(items)
        setLoading(false)
      },
    })
    return () => {
      unsub()
    }
  }, [conjunto.id])

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      <StyledButton
        color="primary"
        variant="contained"
        className="m-2"
        onClick={handleOpen}
      >
        <AccountBalance className="me-2" /> Agregar cuenta
      </StyledButton>
      <Dialog
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <DialogTitle id="delete-dialog-title">
          <Toolbar>
            <Typography align="center" variant="h3">
              Crear Cuenta
            </Typography>
          </Toolbar>
        </DialogTitle>
        <Formik
          initialValues={{
            Banco: "",
            TipoCuenta: "",
            NombreCuenta: "",
            NumeroCuenta: "",
            TipoIdentificacion: "",
            Identificacion: "",
            Correo: "",
            SaldoInicial: "",
            FechaCorte: new Date(),
          }}
          validationSchema={Yup.object().shape({
            Banco: Yup.string()
              .ensure()
              .trim()
              .required("¡Debe seleccionar un banco!"),
            TipoCuenta: Yup.string()
              .ensure()
              .required("¡Seleccione el tipo de cuenta!"),
            TipoIdentificacion: Yup.string().required(
              "¡Seleccione el tipo de identificación!"
            ),
            NombreCuenta: Yup.string()
              .ensure()
              .trim()
              .max(100, "¡Limite máximo de 100 caracteres!")
              .required("¡Se requiere rellenar este campo!"),
            NumeroCuenta: Yup.string()
              .trim()
              .max(25, "¡Limite máximo de 25 caracteres!")
              .required("¡Se requiere rellenar este campo!")
              .matches(/^[0-9]+$/gm, "¡Solo se admiten números!"),
            Correo: Yup.string()
              .max(50, "¡Limite máximo de 50 caracteres!")
              .email("Ingrese un correo Valido!"),
            Identificacion: Yup.string()
              .ensure()
              .trim()
              .max(20, "¡Limite máximo de 20 caracteres!")
              .required("¡Se requiere rellenar este campo!"),
            SaldoInicial: Yup.number()
              .min(0, "¡El valor no puede ser negativo!")
              .max(1000000, "¡El valor no puede ser mayor a un millón!")
              .required("¡Se requiere rellenar este campo!")
              .test(
                "maxDecimals",
                "Se permiten hasta 2 dígitos decimales",
                value => /^\d+(\.\d{0,2})?$/.test(value)
              ),
            FechaCorte: Yup.date().required("La fecha es requerida"),
          })}
          onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
            setLoading(true)
            try {
              const logoBank =
                bancos.find(bank => bank.Nombre === values.Banco)?.Imagen || ""
              const newAccount = await FirestoreService.newAccountBank(
                conjunto.id,
                values,
                logoBank
              )
              if (values.SaldoInicial > 0) {
                const Cobros = [
                  {
                    Rubro: "Saldos iniciales",
                    SubRubro: "Saldo Inicial",
                    Valor: toDecimal(values.SaldoInicial),
                    Descripcion: "Saldo inicial de Cuenta Bancaria",
                  },
                ]

                await FirestoreService.newSaldo(conjunto.id, {
                  Valor: values.SaldoInicial,
                  Descripcion: "Saldo inicial de Cuenta Bancaria",
                  Fecha: values.FechaCorte,
                  Forma: "Saldo inicial",
                  Cobros,
                  CuentaUid: newAccount.id,
                  ComprobanteTransaccion: curNumComp + 1,
                  Usuario: "",
                  Comprobante: "saldo inicial",
                })
                await FirestoreService.updateComprobante(conjunto.id, {
                  Ingreso: curNumComp + 1,
                  Egreso: conjunto.NumeroComprobanteEgreso || 0,
                })
              }
              if (conjunto.cashbook) {
                axios.get(
                  `https://backendphp23.herokuapp.com/web/bank/?values=${JSON.stringify(
                    values
                  )}`
                )
              }
              setStatus({ success: true })
              enqueueSnackbar("Cuenta añadida correctamente", {
                variant: "success",
              })
              handleClose()
            } catch (err) {
              setStatus({ success: false })
              setErrors({ submit: err.message })
            } finally {
              setSubmitting(false)
              setLoading(false)
            }
          }}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            isSubmitting,
            setFieldValue,
            touched,
            values,
          }) =>
            loading ? (
              <Box display="flex" justifyContent="center" my={5}>
                <CircularProgress />
              </Box>
            ) : (
              <form onSubmit={handleSubmit}>
                <DialogContent dividers>
                  <Grid container spacing={2}>
                    {errors.submit && (
                      <Grid item xs={12}>
                        <FormHelperText error>{errors.submit}</FormHelperText>
                      </Grid>
                    )}
                    <Grid item xs={12}>
                      <TextField
                        error={errors.Banco && touched.Banco}
                        helperText={touched.Banco && errors.Banco}
                        fullWidth
                        name="Banco"
                        label="Banco"
                        onChange={handleChange}
                        select
                        SelectProps={{ native: true }}
                        InputLabelProps={{ shrink: true }}
                        value={values.Banco}
                        variant="outlined"
                      >
                        <option value="">seleccionar una opción</option>
                        {bancos.map(banco => (
                          <option key={banco.Nombre} value={banco.Nombre}>
                            {banco.Nombre}
                          </option>
                        ))}
                      </TextField>
                    </Grid>
                    <Grid item md={6} xs={12}>
                      <TextField
                        error={Boolean(errors.TipoCuenta && touched.TipoCuenta)}
                        helperText={touched.TipoCuenta && errors.TipoCuenta}
                        fullWidth
                        name="TipoCuenta"
                        label="Tipo de Cuenta"
                        onChange={handleChange}
                        select
                        SelectProps={{ native: true }}
                        InputLabelProps={{ shrink: true }}
                        value={values.TipoCuenta}
                        variant="outlined"
                      >
                        <option value="">seleccionar una opción</option>
                        {tipoCuenta.map(elem => (
                          <option key={elem.Nombre} value={elem.Nombre}>
                            {elem.Nombre}
                          </option>
                        ))}
                      </TextField>
                    </Grid>
                    <Grid item md={6} xs={12}>
                      <TextField
                        error={errors.NumeroCuenta && touched.NombreCuenta}
                        helperText={touched.NumeroCuenta && errors.NumeroCuenta}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.NumeroCuenta}
                        fullWidth
                        variant="outlined"
                        label="Número de cuenta"
                        name="NumeroCuenta"
                        id="NumeroCuenta"
                      />
                    </Grid>
                    <Grid item md={6} xs={12}>
                      <TextField
                        error={
                          touched.NombreCuenta && Boolean(errors.NombreCuenta)
                        }
                        helperText={touched.NombreCuenta && errors.NombreCuenta}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.NombreCuenta}
                        fullWidth
                        variant="outlined"
                        label="Nombre de la cuenta"
                        name="NombreCuenta"
                        id="NombreCuenta"
                      />
                    </Grid>
                    <Grid item md={6} xs={12}>
                      <TextField
                        error={
                          errors.TipoIdentificacion &&
                          touched.TipoIdentificacion
                        }
                        helperText={
                          touched.TipoIdentificacion &&
                          errors.TipoIdentificacion
                        }
                        fullWidth
                        name="TipoIdentificacion"
                        label="Tipo de identificación"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        select
                        SelectProps={{ native: true }}
                        InputLabelProps={{ shrink: true }}
                        value={values.TipoIdentificacion}
                        variant="outlined"
                      >
                        <option value="">seleccionar una opción</option>
                        {tipoIdentificacion.map(tipoIdeniIficacion => (
                          <option
                            key={tipoIdeniIficacion.Nombre}
                            value={tipoIdeniIficacion.Nombre}
                            defaultValue=""
                          >
                            {tipoIdeniIficacion.Nombre}
                          </option>
                        ))}
                      </TextField>
                    </Grid>
                    <Grid item md={6} xs={6}>
                      <TextField
                        error={errors.Identificacion && touched.Identificacion}
                        helperText={
                          touched.Identificacion && errors.Identificacion
                        }
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.Identificacion}
                        fullWidth
                        variant="outlined"
                        label="Identificación"
                        name="Identificacion"
                        id="Identificacion"
                      />
                    </Grid>
                    <Grid item md={6} xs={12}>
                      <TextField
                        error={errors.Correo && touched.Correo}
                        helperText={
                          errors.Correo && touched.Correo && errors.Correo
                        }
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.Correo}
                        fullWidth
                        variant="outlined"
                        label="Correo electrónico"
                        name="Correo"
                        id="Correo"
                      />
                    </Grid>
                    <Grid item xs={6} md={6}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        error={Boolean(
                          touched.SaldoInicial && errors.SaldoInicial
                        )}
                        helperText={touched.SaldoInicial && errors.SaldoInicial}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.SaldoInicial}
                        label="Saldo Inicial"
                        name="SaldoInicial"
                        id="SaldoInicial"
                        type="number"
                      />
                    </Grid>
                    <Grid item md={6}>
                      <DatePicker
                        error={touched.FechaCorte && Boolean(errors.FechaCorte)}
                        helperText={touched.FechaCorte && errors.FechaCorte}
                        format="DD/MM/YYYY"
                        name="FechaCorte"
                        inputVariant="outlined"
                        variant="inline"
                        disableToolbar
                        fullWidth
                        label="Fecha de Corte"
                        autoOk
                        autoComplete="false"
                        value={values.FechaCorte}
                        onChange={date =>
                          setFieldValue("FechaCorte", date.toDate())
                        }
                      />
                    </Grid>
                  </Grid>
                </DialogContent>
                <DialogActions>
                  <StyledButton
                    variant="outlined"
                    autoFocus
                    onClick={handleClose}
                    color="primary"
                    startIcon={<Block fontSize="small" />}
                  >
                    Cancelar
                  </StyledButton>
                  <StyledButton
                    color="primary"
                    disabled={isSubmitting}
                    type="submit"
                    variant="contained"
                    startIcon={<AddShoppingCartIcon fontSize="small" />}
                  >
                    Agregar
                  </StyledButton>
                </DialogActions>
              </form>
            )
          }
        </Formik>
      </Dialog>
    </>
  )
}

export default NewBank
